import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RestApiWrapperService {

  constructor(public http: HttpClient) {
  }

}
